export const environment = {
  ENV: 'dit',
  AUTH_ENABLED: true,
  APP: 'asm-licensing',
  THEME: 'sol-dark',
  KEYCLOAK_REALM: 'asm',
  KEYCLOAK_URL: 'https://asm-auth.ditext.outpost24.com/auth',
  KEYCLOAK_CLIENT_ID: 'asm-licensing',
  ASM_API_URL: 'https://asm-backend.ditext.outpost24.com',
  LICENSE_SERVICE_QUERY_URL: 'https://license.ditext.outpost24.com/api',
  LICENSE_SERVICE_COMMAND_URL: 'https://license-cmd.ditext.outpost24.com/api',
  HTTP_MOCKS: [],
};
